import { EncaminhamentoInternoInput, EscutaInicialInput, ProcedimentoAtendimentoInput } from 'graphql/types.generated'

import { convertAgendarConsulta } from '../detail/soap/finalizacao/components/agendar-consulta/converter-agendarConsultaAtendimento'
import { ManterCidadaoLista } from '../detail/soap/finalizacao/components/DesfechoAtendimentoPanel'
import { ProcedimentoSigtapFieldModel } from '../detail/soap/finalizacao/components/ProcedimentoSigtapField'
import { convertMedicoesPanelToInput } from '../detail/soap/objetivo'
import { EscutaInicialState } from './model-escutaInicial'

export const convertEscutaInicialModelToInput = (
  atendimentoId: ID,
  values: EscutaInicialState,
  isPreAtendimento: boolean
): EscutaInicialInput => ({
  id: atendimentoId,
  ciapId: values.motivoConsulta.ciap.id,
  motivoConsulta: values.motivoConsulta.texto,
  medicoes: convertMedicoesPanelToInput(values.sinaisVitais, values.antropometria),
  desfecho: {
    manterCidadaoLista: isPreAtendimento || values.desfecho.manterCidadaoLista === ManterCidadaoLista.SIM,
    atendimento: convertAtendimentoDesfecho(values, isPreAtendimento),
  },
  classificacaoRiscoEnum: isPreAtendimento ? undefined : values.classificacaoRisco,
  procedimentos: convertProcedimentos(values.procedimentos?.procedimentosSigtap),
  procedimentosAdministrativos: convertProcedimentos(values.procedimentosAdministrativos),
  agendamentoConsulta: isPreAtendimento ? undefined : convertAgendarConsulta(values?.agendamentoConsulta?.avulsa),
  imprimirEscuta: values.imprimirEscutaInicial,
})

const convertAtendimentoDesfecho = (
  values: EscutaInicialState,
  isPreAtendimento: boolean
): EncaminhamentoInternoInput =>
  isPreAtendimento || values.desfecho.manterCidadaoLista === ManterCidadaoLista.SIM
    ? {
        equipe: values.desfecho.atendimento?.equipe?.id,
        responsavel: values.desfecho.atendimento?.responsavel?.id,
        tiposServico: values.desfecho.atendimento?.tiposServico,
      }
    : undefined

const convertProcedimentos = (listaProcedimentos: ProcedimentoSigtapFieldModel[]): ProcedimentoAtendimentoInput[] =>
  listaProcedimentos?.map((procedimento) => ({
    id: procedimento.procedimento.id,
    cid10PrincipalId: procedimento.procedimento.procedimentoReferencia?.id,
    automatico: procedimento.automatico,
  })) ?? []
